export enum CarPurchaseAdditionalPersonType {
  POLICYHOLDER = 'policyholder',
  DRIVER = 'driver',
  BOTH = 'both',
}
